// PortalBreakout — 150 level definitions + brick type table (see CONTRACT.md)
// Each level: exactly 14 row strings of exactly 13 chars. '.' = empty cell.

export const BRICK_TYPES = {
  // char → { hp, points, color, name } ; hp Infinity for gold
  '1': { hp: 1, points: 50,  color: '#ef5350', name: 'red' },
  '2': { hp: 1, points: 60,  color: '#ff9800', name: 'orange' },
  '3': { hp: 1, points: 70,  color: '#ffeb3b', name: 'yellow' },
  '4': { hp: 1, points: 80,  color: '#66bb6a', name: 'green' },
  '5': { hp: 1, points: 90,  color: '#26c6da', name: 'cyan' },
  '6': { hp: 1, points: 100, color: '#42a5f5', name: 'blue' },
  '7': { hp: 1, points: 110, color: '#ab47bc', name: 'purple' },
  '8': { hp: 1, points: 120, color: '#ec407a', name: 'pink' },
  'S': { hp: 2, points: 150, color: '#b0bec5', name: 'silver' },
  'G': { hp: Infinity, points: 0, color: '#ffd54f', name: 'gold' },
  'E': { hp: 1, points: 150, color: '#ff7043', name: 'explosive' },
  'P': { hp: 1, points: 100, color: '#7e57c2', name: 'powerup' },
};

export const LEVELS = [
  {
    name: 'Test Chamber 01',
    rows: [
      '.............',
      '.............',
      '.............',
      '.4.4.4.4.4.4.',
      '.............',
      '.5.5.5.5.5.5.',
      '.............',
      '.6.6.6.6.6.6.',
      '.............',
      '.............',
      '.............',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Aperture Orientation',
    rows: [
      '.............',
      '.............',
      '3333333......',
      '.............',
      '......4444444',
      '.............',
      '5555555......',
      '.............',
      '......6666666',
      '.............',
      '.............',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Rainbow Protocol',
    rows: [
      '.............',
      '.............',
      '1111111111111',
      '2222222222222',
      '3333333333333',
      '4444444444444',
      '5555555555555',
      '6666666666666',
      '.............',
      '.............',
      '.............',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Pyramid Scheme',
    rows: [
      '.............',
      '.............',
      '......1......',
      '.....222.....',
      '....33333....',
      '...4444444...',
      '..555555555..',
      '.66666666666.',
      '7777777777777',
      '.............',
      '.............',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Doh It Again',
    rows: [
      '.............',
      '.............',
      '7777777777777',
      '.66666666666.',
      '..555555555..',
      '...4444444...',
      '....33333....',
      '.....222.....',
      '......1......',
      '.............',
      '.............',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Diamond Mine',
    rows: [
      '.............',
      '.............',
      '......5......',
      '.....555.....',
      '....55555....',
      '...5555555...',
      '..5555P5555..',
      '...5555555...',
      '....55555....',
      '.....555.....',
      '......5......',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Checkerboard Chamber',
    rows: [
      '.............',
      '.............',
      '4.4.4.4.4.4.4',
      '.6.6.6.6.6.6.',
      '4.4.4.4.4.4.4',
      '.6.6.6.6.6.6.',
      '4.4.4.4.4.4.4',
      '.6.6.6.6.6.6.',
      '4.4.4.4.4.4.4',
      '.6.6.6.6.6.6.',
      '.............',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Chevron Facility',
    rows: [
      '.............',
      '.............',
      '55...555...55',
      '.55.55.55.55.',
      '..555...555..',
      '.............',
      '66...666...66',
      '.66.66.66.66.',
      '..666...666..',
      '.............',
      '77...777...77',
      '.77.77.77.77.',
      '..777...777..',
      '.............',
    ],
  },
  {
    name: 'The Watchtowers',
    rows: [
      '.............',
      '.............',
      '33.........33',
      '33.........33',
      '44.........44',
      '44.........44',
      '55...666...55',
      '55...666...55',
      '44.........44',
      '44.........44',
      '33.........33',
      '33.........33',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Cascade Failure',
    rows: [
      '.............',
      '.............',
      '222..........',
      '.333.........',
      '..444........',
      '...555.......',
      '....666......',
      '.....777.....',
      '......888....',
      '.......222...',
      '........333..',
      '.........444.',
      '..........555',
      '.............',
    ],
  },
  {
    name: 'Companion Cube',
    rows: [
      '.............',
      '.............',
      '..SSSSSSSSS..',
      '..SSSSSSSSS..',
      '..SSS8S8SSS..',
      '..SS88888SS..',
      '..SS88888SS..',
      '..SSS888SSS..',
      '..SSSS8SSSS..',
      '..SSSSSSSSS..',
      '..SSSSSSSSS..',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'The Cake',
    rows: [
      '.............',
      '.............',
      '......2......',
      '......3......',
      '......3......',
      '..88P888P88..',
      '..888888888..',
      '..111111111..',
      '..888888888..',
      '..111111111..',
      '.SSSSSSSSSSS.',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Turret Ops',
    rows: [
      '.............',
      '.............',
      '....SSSSS....',
      '...SSSSSSS...',
      '...SSS1SSS...',
      '...SSSSSSS...',
      '...SSSSSSS...',
      '....SSSSS....',
      '....S.S.S....',
      '...S..S..S...',
      '..S...S...S..',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Ring Toss',
    rows: [
      '.............',
      '.............',
      '...2222222...',
      '..2.......2..',
      '..2...P...2..',
      '...2222222...',
      '.............',
      '.............',
      '...6666666...',
      '..6.......6..',
      '..6...P...6..',
      '...6666666...',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Keep Smiling',
    rows: [
      '.............',
      '.............',
      '....33333....',
      '..333333333..',
      '.33663336633.',
      '.33333333333.',
      '.36333333363.',
      '.33666666633.',
      '.33333333333.',
      '..333333333..',
      '....33333....',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Heartbreaker',
    rows: [
      '.............',
      '.............',
      '..888...888..',
      '.88888.88888.',
      '8888888888888',
      '888888P888888',
      '.88888888888.',
      '..888888888..',
      '...8888888...',
      '....88888....',
      '.....888.....',
      '......8......',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Space Invader',
    rows: [
      '.............',
      '.............',
      '...4.....4...',
      '....4...4....',
      '...4444444...',
      '..44.444.44..',
      '.44444444444.',
      '.4.4444444.4.',
      '.4.4.....4.4.',
      '....44.44....',
      '.............',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'The Monogram',
    rows: [
      '.............',
      '.............',
      '.2222..6666..',
      '.2...2.6...6.',
      '.2...2.6...6.',
      '.2222..6666..',
      '.2.....6...6.',
      '.2.....6...6.',
      '.2.....6666..',
      '.............',
      '.............',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'X Marks the Chamber',
    rows: [
      '.............',
      '.............',
      '.77.......77.',
      '..77.....77..',
      '...77...77...',
      '....77.77....',
      '.....777.....',
      '......E......',
      '.....777.....',
      '....77.77....',
      '...77...77...',
      '..77.....77..',
      '.77.......77.',
      '.............',
    ],
  },
  {
    name: 'Boxes in Boxes',
    rows: [
      '.............',
      '.............',
      '5555555555555',
      '5...........5',
      '5.666666666.5',
      '5.6.......6.5',
      '5.6.77777.6.5',
      '5.6.7.P.7.6.5',
      '5.6.77777.6.5',
      '5.6.......6.5',
      '5.666666666.5',
      '5...........5',
      '5555555555555',
      '.............',
    ],
  },
  {
    name: 'Centrifuge',
    rows: [
      '.............',
      '.............',
      '7777777777777',
      '............7',
      '77777777777.7',
      '7.........7.7',
      '7.7777777.7.7',
      '7.7.....7.7.7',
      '7.7.77777.7.7',
      '7.7.......7.7',
      '7.777777777.7',
      '7...........7',
      '7777777777777',
      '.............',
    ],
  },
  {
    name: 'Butterfly Effect',
    rows: [
      '.............',
      '.............',
      '....7...7....',
      '.77...5...77.',
      '78887.5.78887',
      '78887.5.78887',
      '.7887.5.7887.',
      '..787.5.787..',
      '.787..5..787.',
      '.77...5...77.',
      '......5......',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Vaus Mothership',
    rows: [
      '.............',
      '.............',
      '......5......',
      '.....555.....',
      '....55555....',
      '....56665....',
      '...5555555...',
      '..555555555..',
      '.55.55555.55.',
      '55...555...55',
      '..2...2...2..',
      '..2...2...2..',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Still Watching',
    rows: [
      '.............',
      '.............',
      '.55.......55.',
      '.............',
      '....GG.GG....',
      '..GG.....GG..',
      '.G...333...G.',
      '.G...323...G.',
      '.G...333...G.',
      '..GG.....GG..',
      '....GG.GG....',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Aperture Fan',
    rows: [
      '.............',
      '.............',
      '.............',
      '......5......',
      '...5..5..5...',
      '....5.5.5....',
      '.....555.....',
      '..5555E5555..',
      '.....555.....',
      '....5.5.5....',
      '...5..5..5...',
      '......5......',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Tunnel Vision',
    rows: [
      '.............',
      '.............',
      '.S.S.S.S.S.S.',
      '.4.5.6.7.6.5.',
      '.4.5.6.7.6.5.',
      '.4.5.6.7.6.5.',
      '.4.5.6.7.6.5.',
      '.4.5.6.7.6.5.',
      '.4.5.6.7.6.5.',
      '.4.5.6.7.6.5.',
      '.4.5.6.7.6.5.',
      '.S.S.S.S.S.S.',
      '.............',
      '.............',
    ],
  },
  {
    name: 'The Fortress',
    rows: [
      '.............',
      '.............',
      '.............',
      'GGGG.GGG.GGGG',
      'G...........G',
      'G..7777777..G',
      'G..7SSSSS7..G',
      'G..7S7P7S7..G',
      'G..7SSSSS7..G',
      'G..7777777..G',
      'G...........G',
      'GGGG.GGG.GGGG',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Silver Lining',
    rows: [
      '.............',
      '.............',
      '7.7.7.7.7.7.7',
      '.............',
      '.SSS.SSS.SSS.',
      '.SPS.SPS.SPS.',
      '.SSS.SSS.SSS.',
      '.............',
      '6.6.6.6.6.6.6',
      '.............',
      '.............',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Chain Reaction',
    rows: [
      '.............',
      '.............',
      'E88888888888E',
      '8E888888888E8',
      '88E8888888E88',
      '888E88888E888',
      '8888E888E8888',
      '88888E8E88888',
      '888888E888888',
      '.............',
      '.............',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Sniper Alley',
    rows: [
      '.............',
      '.............',
      '.............',
      '.SS.......SS.',
      '.SS.......SS.',
      '.............',
      '.............',
      '.....SS......',
      '.....PP......',
      '.............',
      '.............',
      '.SS.......SS.',
      '.SS.......SS.',
      '.............',
    ],
  },
  {
    name: 'Doh Remastered',
    rows: [
      '.............',
      '.............',
      '..SSSSSSSSS..',
      '.SSSSSSSSSSS.',
      '.SS22SSS22SS.',
      '.SS22SSS22SS.',
      '.SSSSSSSSSSS.',
      '.SSS11111SSS.',
      '.SS1111111SS.',
      '.SS1111111SS.',
      '.SSS11111SSS.',
      '..SSSSSSSSS..',
      '...SSSSSSS...',
      '.............',
    ],
  },
  {
    name: 'The Incinerator',
    rows: [
      '.............',
      '.............',
      '.............',
      'G.G.G.G.G.G.G',
      '.............',
      '.............',
      '.............',
      '2...2...2...2',
      '2.2.2.2.2.2.2',
      '2222222222222',
      '1111111111111',
      '11E111E111E11',
      '.............',
      '.............',
    ],
  },
  {
    name: 'The Lattice',
    rows: [
      '.............',
      '.............',
      'G...G...G...G',
      '.555.555.555.',
      'G...G...G...G',
      '.666.666.666.',
      'G...G...G...G',
      '.777.777.777.',
      'G...G...G...G',
      '.888.888.888.',
      'G...G...G...G',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Still Alive',
    rows: [
      '.............',
      '.............',
      '..777777.....',
      '..7....7.....',
      '..7....7.....',
      '.77...77.....',
      '.77...77.....',
      '......888888.',
      '......8....8.',
      '......8....8.',
      '.....88...88.',
      '.....88...88.',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Turret Choir',
    rows: [
      '.............',
      '.............',
      '.............',
      '.............',
      '.SSS.SSS.SSS.',
      '.S1S.S1S.S1S.',
      '.SSS.SSS.SSS.',
      '.S.S.S.S.S.S.',
      '.S.S.S.S.S.S.',
      '.............',
      '.............',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Emancipation Grill',
    rows: [
      '.............',
      '.............',
      '.............',
      'G55555555555G',
      '.............',
      'G55555555555G',
      '.............',
      'G55555555555G',
      '.............',
      'G55555555555G',
      '.............',
      'G55555555555G',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Weighted Storage',
    rows: [
      '.............',
      '.............',
      '.............',
      '.............',
      '.....SSS.....',
      '.....S8S.....',
      '.....SSS.....',
      '.............',
      '.SSS.....SSS.',
      '.S8S.....S8S.',
      '.SSS.....SSS.',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Hard Light Bridge',
    rows: [
      '.............',
      '.............',
      '.............',
      '5555555555555',
      '.S....S....S.',
      '.S....S....S.',
      '5555555555555',
      '.S....S....S.',
      '.S....S....S.',
      '5555555555555',
      '.............',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Signage Required',
    rows: [
      '.............',
      '.............',
      '.............',
      '.SSSSSSSSSSS.',
      '.S.........S.',
      '.S....3....S.',
      '.S...333...S.',
      '.S..33333..S.',
      '.S....3....S.',
      '.S.2.2.2.2.S.',
      '.SSSSSSSSSSS.',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Turret Prime',
    rows: [
      '.............',
      '.............',
      '....SSSSS....',
      '...SSSSSSS...',
      '...SSSESSS...',
      '...SSSSSSS...',
      '....SSSSS....',
      '....G.G.G....',
      '...G..G..G...',
      '..G...G...G..',
      '.............',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Double Rainbow',
    rows: [
      '.............',
      '.............',
      '1111111111111',
      '2222222222222',
      '3333333333333',
      'SSSSSSSSSSSSS',
      '.............',
      '.............',
      '4444444444444',
      '5555555555555',
      '6666666666666',
      'SSSSSSSSSSSSS',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Gold Rush',
    rows: [
      '.............',
      '.............',
      '.............',
      'G.G.G.G.G.G.G',
      '.3.3.3.3.3.3.',
      'G.G.G.G.G.G.G',
      '.3.P.3.3.P.3.',
      'G.G.G.G.G.G.G',
      '.3.3.3.3.3.3.',
      'G.G.G.G.G.G.G',
      '.............',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Core Meltdown',
    rows: [
      '.............',
      '.............',
      '.............',
      '....77777....',
      '..777777777..',
      '.77SSSSSSS77.',
      '.7SS22222SS7.',
      '.7SS2EEE2SS7.',
      '.7SS22222SS7.',
      '.77SSSSSSS77.',
      '..777777777..',
      '....77777....',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Neurotoxin',
    rows: [
      '.............',
      '.............',
      '.............',
      '..444444444..',
      '.44444444444.',
      '.44.44444.44.',
      '.44.44444.44.',
      '.44444.44444.',
      '..444444444..',
      '..4.4.4.4.4..',
      '.............',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Wheatley',
    rows: [
      '.............',
      '.............',
      '.............',
      '....66666....',
      '..666666666..',
      '.666SSSSS666.',
      '.66SS555SS66.',
      '.666SSSSS666.',
      '..666666666..',
      '....66666....',
      '.............',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Aperture Overdrive',
    rows: [
      '.............',
      '.............',
      '.............',
      '......S......',
      '...S..S..S...',
      '....S.S.S....',
      '.....SSS.....',
      '..SSSSESSSS..',
      '.....SSS.....',
      '....S.S.S....',
      '...S..S..S...',
      '......S......',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Shooting Gallery',
    rows: [
      '.............',
      '.............',
      '.............',
      '.............',
      '.GGG.GGG.GGG.',
      '.3P3.3P3.3P3.',
      '.333.333.333.',
      '.............',
      '6.6.6.6.6.6.6',
      '.............',
      '.............',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'The Central Core',
    rows: [
      '.............',
      '.............',
      '..S...S...S..',
      '...GGG.GGG...',
      '.GG.......GG.',
      'G....222....G',
      'G...22E22...G',
      'G....222....G',
      '.GG.......GG.',
      '...GGG.GGG...',
      '.............',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Victory Candescence',
    rows: [
      '.............',
      '.............',
      '..E...E...E..',
      '..3...3...3..',
      '..3...3...3..',
      '.88888888888.',
      '.8P8888888P8.',
      '.11111111111.',
      '.88888888888.',
      '.11111111111.',
      'SSSSSSSSSSSSS',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'The Final Chamber',
    rows: [
      '.............',
      '.............',
      '1111111111111',
      '.SSSSSSSSSSS.',
      '.S....2....S.',
      '.S.G.222.G.S.',
      '.S.G22E22G.S.',
      '.S.G.222.G.S.',
      '.S....2....S.',
      '.SSSSSSSSSSS.',
      '..P.......P..',
      '1111111111111',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Eight-Bit Invader',
    rows: [
      '.............',
      '.............',
      '.............',
      '...7.....7...',
      '....7...7....',
      '...4444444...',
      '..445444544..',
      '.44444444444.',
      '.4.4444444.4.',
      '.4.4.....4.4.',
      '....44.44....',
      '.............',
      '.SS..EPE..SS.',
      '.............',
    ],
  },
  {
    name: 'Bonehead',
    rows: [
      '.............',
      '...5555555...',
      '.55555P55555.',
      '5555555555555',
      '55...555...55',
      '55.E.555.E.55',
      '555555.555555',
      '.5555...5555.',
      '.55555555555.',
      '..SSSSSSSSS..',
      '...S.S.S.S...',
      '...SSSSSSS...',
      '.....555.....',
      '.............',
    ],
  },
  {
    name: 'Prism Stack',
    rows: [
      '.............',
      '.............',
      '111.11111.111',
      '222.22222.222',
      '333.33333.333',
      '444.44444.444',
      '555.55555.555',
      '666.66666.666',
      '777.77777.777',
      '888.8P8P8.888',
      '.............',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Escape Velocity',
    rows: [
      '......S......',
      '.....S1S.....',
      '....S111S....',
      '....S1P1S....',
      '....S111S....',
      '....S111S....',
      '...6S111S6...',
      '..66S111S66..',
      '.666S111S666.',
      '.666SSSSS666.',
      '.....EEE.....',
      '......E......',
      '.....3.3.....',
      '.............',
    ],
  },
  {
    name: 'OK Signal',
    rows: [
      '.............',
      '.33333333333.',
      '.............',
      '..444..5...5.',
      '.4...4.5..5..',
      '.4...4.5.5...',
      '.4.P.4.55....',
      '.4...4.5.5...',
      '.4...4.5..5..',
      '..444..5...5.',
      '.............',
      '.33333E33333.',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Orchard Oak',
    rows: [
      '.............',
      '....44444....',
      '...4414144...',
      '..444444444..',
      '.41444P44414.',
      '.44444444444.',
      '..414444414..',
      '...4444444...',
      '....41414....',
      '.....222.....',
      '.....2E2.....',
      '.....222.....',
      '..22.222.22..',
      '.............',
    ],
  },
  {
    name: 'The Coil',
    rows: [
      '.............',
      '...GG...GG...',
      '..777777777..',
      '..7GG...GG7..',
      '..7G55555G7..',
      '..7G5...5G7..',
      '..7G5.P.5G7..',
      '..7G5.E.5G7..',
      '..7G5...5G7..',
      '..7G55555G7..',
      '..7GG...GG7..',
      '..777777777..',
      '...GG...GG...',
      '.............',
    ],
  },
  {
    name: 'Castling',
    rows: [
      '.............',
      '..S.S.S.S.S..',
      '..666666666..',
      '...7777777...',
      '....77777....',
      '....77P77....',
      '.....888.....',
      '.....888.....',
      '.....8E8.....',
      '....77777....',
      '...7777777...',
      '..SSSSSSSSS..',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Echo Wings',
    rows: [
      '.............',
      '.............',
      '.............',
      '.............',
      '.7...8.8...7.',
      '.77.88888.77.',
      '.77781818777.',
      '.77778887777.',
      '..7E77777E7..',
      '...77.7.77...',
      '....7.P.7....',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'North Star',
    rows: [
      '.............',
      '......3......',
      '.....333.....',
      '....33333....',
      '3E333333333E3',
      '.22222222222.',
      '..2222P2222..',
      '...2222222...',
      '...111.111...',
      '..111...111..',
      '.111.....111.',
      '111.......111',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Step Ladder',
    rows: [
      '.............',
      '..G.......G..',
      '..G3333333G..',
      '..G.......G..',
      '..G4444444G..',
      '..G.......G..',
      '..G5P555P5G..',
      '..G.......G..',
      '..G6666666G..',
      '..G.......G..',
      '..G7777777G..',
      '..G.......G..',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Uplink Array',
    rows: [
      '.............',
      '......3......',
      '.....333.....',
      '......3......',
      '.....SSS.....',
      '6556.S8S.6556',
      '56655S8S55665',
      '56655SES55665',
      '6556.S8S.6556',
      '.....SSS.....',
      '......5......',
      '.....P.P.....',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Forty-Two',
    rows: [
      '.............',
      '.............',
      '.............',
      '....3...888..',
      '...33..8...8.',
      '..3.3......8.',
      '.3..3.....8..',
      '.33E33...8...',
      '....3...8....',
      '....3..88P88.',
      '.............',
      '..SSSSSSSSS..',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Petal Bloom',
    rows: [
      '.............',
      '.............',
      '..88.888.88..',
      '..88.888.88..',
      '.888.333.888.',
      '.888.EPE.888.',
      '.888.333.888.',
      '..88.888.88..',
      '..88.888.88..',
      '......4......',
      '...44.4.44...',
      '..444.4.444..',
      '......4......',
      '.............',
    ],
  },
  {
    name: 'Switchback',
    rows: [
      '.............',
      '..P888888888.',
      '.GGGGGG......',
      '.7777777777..',
      '........GGGG.',
      '..6666666666.',
      '.GGGGGG......',
      '.5555555555..',
      '........GGGG.',
      '..4444444444.',
      '.GGGGGG......',
      '.333333333P..',
      '........GGGG.',
      '......E......',
    ],
  },
  {
    name: 'Lucky Seven',
    rows: [
      '.............',
      '.............',
      '66666...55555',
      '63..6...58.85',
      '63..6...58.85',
      '6...6...5...5',
      '6.P.6...5...5',
      '6.3.6...5...5',
      '6...6...5...5',
      '6..36...5E.E5',
      '6..36...5E.E5',
      '66666...55555',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Curious Cat',
    rows: [
      '.............',
      '.............',
      '.22.......22.',
      '.2222...2222.',
      '..222222222..',
      '.22222222222.',
      '.22442224422.',
      '.S.2228222.S.',
      '.S.22.2.22.S.',
      '..2E22222E2..',
      '...2222222...',
      '....22P22....',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Lockdown',
    rows: [
      '.............',
      '....SSSSS....',
      '...SS...SS...',
      '..SS.....SS..',
      '..SS.....SS..',
      '..SS.....SS..',
      '..222222222..',
      '.22222222222.',
      '.2222...2222.',
      '.222E2.2E222.',
      '.22222.22222.',
      '.22222P22222.',
      '..222222222..',
      '.............',
    ],
  },
  {
    name: 'Zigzag Reactor',
    rows: [
      '.............',
      '8...8...8...8',
      '.8.8.8.8.8.8.',
      '..8...P...8..',
      '.............',
      '..5...5...5..',
      '.5.5.5.5.5.5.',
      '5...5...5...5',
      '.............',
      '3...3...3...3',
      '.3.3.3.3.3.3.',
      '..3...3...3..',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Saucer Sighting',
    rows: [
      '.............',
      '.....444.....',
      '....44444....',
      '...5555555...',
      '.SSSSSSSSSSS.',
      '.3.3.3.3.3.3.',
      '...5555555...',
      '.....555.....',
      '....8...8....',
      '...8.....8...',
      '...8..P..8...',
      '..8.......8..',
      '..8.......8..',
      '..E.......E..',
    ],
  },
  {
    name: 'Say Hi',
    rows: [
      '.............',
      '.............',
      '.............',
      '.6...6.33333.',
      '.6...6...3...',
      '.6...6...3...',
      '.66P66...3...',
      '.6...6...3...',
      '.6...6...3...',
      '.6...6.33333.',
      '.............',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Toadstool',
    rows: [
      '.............',
      '....11111....',
      '..1S11111S1..',
      '.11111E11111.',
      '.1S1111111S1.',
      '.11S11111S11.',
      '..111111111..',
      '.....SSS.....',
      '.....SPS.....',
      '.....SSS.....',
      '....SSSSS....',
      '...44...44...',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Bullseye',
    rows: [
      '.............',
      '...GG...GG...',
      '..GG.....GG..',
      '.G..88888..G.',
      '.G.8.....8.G.',
      'G..8.555.8..G',
      'G..85.E.58..G',
      'G..85.P.58..G',
      'G..8.555.8..G',
      '.G.8.....8.G.',
      '.G..88888..G.',
      '..GG.....GG..',
      '...GG...GG...',
      '.............',
    ],
  },
  {
    name: 'Press Start',
    rows: [
      '.............',
      '.............',
      '.............',
      '..66.....66..',
      '.66666666666.',
      '66.3.666.8.66',
      '663336P68.866',
      '66.3.666.8.66',
      '.66666666666.',
      '.SS.......SS.',
      'SS.........SS',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Web Spinner',
    rows: [
      '.............',
      '.............',
      '.8.........8.',
      '..8.......8..',
      '...8.....8...',
      '8...77777...8',
      '.8..11711..8.',
      '..S.77777.S..',
      '...S77E77S...',
      '..S.77P77.S..',
      '.8..77777..8.',
      '8...77777...8',
      '...8.....8...',
      '.............',
    ],
  },
  {
    name: 'High Voltage',
    rows: [
      '.............',
      '.............',
      '.66666633P66.',
      '.66666333666.',
      '.66663336666.',
      '.66633E33366.',
      '.66333E33666.',
      '.66663336666.',
      '.66633366666.',
      '.66333666666.',
      '.66336666666.',
      '.66636666666.',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Rhombus Nest',
    rows: [
      '......6......',
      '.....6.6.....',
      '....6.5.6....',
      '...6.5.5.6...',
      '..6.5.8.5.6..',
      '.6.5.8.8.5.6.',
      '6.5.8.P.8.5.6',
      '.6.5.8.8.5.6.',
      '..6.5.8.5.6..',
      '...6.5.5.6...',
      '....6.5.6....',
      '.....6.6.....',
      '......6......',
      '.............',
    ],
  },
  {
    name: 'Ringed Giant',
    rows: [
      '.............',
      '.....333.....',
      '....33333....',
      '...3333333...',
      '...2222222...',
      '...2222222...',
      'SSSSSSSSSSSSS',
      '...1111111...',
      '...1111111...',
      '...1111111...',
      '....11111....',
      '.....111.....',
      '..P.......P..',
      '.............',
    ],
  },
  {
    name: 'Hard No',
    rows: [
      '.............',
      '.............',
      '777777E777777',
      '71...1..111.7',
      '711..1.1...17',
      '711..1.1...17',
      '71.1.1.1.P.17',
      '71..11.1...17',
      '71..11.1...17',
      '71...1..111.7',
      '777777E777777',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Leaf Vein',
    rows: [
      '.............',
      '......4......',
      '.....424.....',
      '....44244....',
      '...4442444...',
      '..444424444..',
      '.44E44244E44.',
      '.44P44244P44.',
      '..444424444..',
      '...4442444...',
      '....44244....',
      '.....424.....',
      '......2......',
      '.............',
    ],
  },
  {
    name: 'The Comb',
    rows: [
      '.............',
      '8.8.8.8.8.8.8',
      '8G8G8G8G8G8G8',
      '7G7G7G7G7G7G7',
      '7G7G7G7G7G7G7',
      '6G6G6G6G6G6G6',
      '6G6G6G6G6G6G6',
      '5G5G5GEG5G5G5',
      '5G5G5GEG5G5G5',
      '4G4G4GEG4G4G4',
      '4G4G4GEG4G4G4',
      'P.....E.....P',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Fresh Brew',
    rows: [
      '.............',
      '....5...5....',
      '.....5.5.....',
      '....5...5....',
      '..5555555....',
      '..2222222....',
      '..8888888SSS.',
      '..888P888..S.',
      '..3333333..S.',
      '..8888888SSS.',
      '..8888888....',
      '..SSSSSSS....',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Pincer Patrol',
    rows: [
      '.............',
      '.............',
      '.EE.......EE.',
      '.111.....111.',
      '..11.....11..',
      '...1.3.3.1...',
      '..111111111..',
      '.11111P11111.',
      '.111.111.111.',
      '..111111111..',
      '...1111111...',
      '..1.1...1.1..',
      '.1..1...1..1.',
      '.............',
    ],
  },
  {
    name: 'Anchor Point',
    rows: [
      '.............',
      '.....SSS.....',
      '.....SPS.....',
      '.....SSS.....',
      '..666656666..',
      '......5......',
      '......5......',
      '......5......',
      'S.....5.....S',
      'S.....5.....S',
      'SS....5....SS',
      '.SS...5...SS.',
      '..ESSSSSSSE..',
      '.............',
    ],
  },
  {
    name: 'Ziggurat',
    rows: [
      '.............',
      '.............',
      '.....333.....',
      '.....3P3.....',
      '...4444444...',
      '...4444444...',
      '.66666666666.',
      '.66666666666.',
      'SSSSS...SSSSS',
      '77777...77777',
      '.............',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Star Chart',
    rows: [
      '...3.....3...',
      '.............',
      '......8......',
      '.....6.6.....',
      '....6...6....',
      '...6.....6...',
      '..P...8...P..',
      '...6.....6...',
      '....6...6....',
      '.....6.6.....',
      '......8......',
      '.............',
      '...3.....3...',
      '.............',
    ],
  },
  {
    name: 'Double Good',
    rows: [
      '.............',
      '.............',
      '.............',
      '..444...555..',
      '.4.P.4.5.P.5.',
      '.4.....5.....',
      '.4.444.5.555.',
      '.4...4.5...5.',
      '.4...4.5...5.',
      '..444...555..',
      '.............',
      '..EEEEEEEEE..',
      '.............',
      '.............',
    ],
  },
  {
    name: 'First Frost',
    rows: [
      'S.....5.....S',
      '.5....5....5.',
      '..5..555..5..',
      '...5..5..5...',
      '....5.5.5....',
      '.....555.....',
      'S55555P55555S',
      '.....555.....',
      '....5.5.5....',
      '...5..5..5...',
      '..5..555..5..',
      '.5....5....5.',
      'S.....5.....S',
      '.............',
    ],
  },
  {
    name: 'The Keep',
    rows: [
      '.............',
      '.S.SSSSSSS.S.',
      '.SSS.....SSS.',
      '.S.GGGGGGG.S.',
      '.6.G.....G.6.',
      '.6.G.888.G.6.',
      '.6.G.8P8.G.6.',
      '.6.G.888.G.6.',
      '.6.G.....G.6.',
      '.S.GGG.GGG.S.',
      '.SSS.....SSS.',
      '.S.SSSSSSS.S.',
      '..E.......E..',
      '.............',
    ],
  },
  {
    name: 'Liftoff',
    rows: [
      '.............',
      '......1......',
      '.....111.....',
      '....11111....',
      '....55555....',
      '....56P65....',
      '....56665....',
      '....55555....',
      '....55555....',
      '...S55555S...',
      '..SS55555SS..',
      '.SSS55555SSS.',
      '.....EEE.....',
      '......E......',
    ],
  },
  {
    name: 'Night Owl',
    rows: [
      '.............',
      '.............',
      '.6.........6.',
      '.66.......66.',
      '..666666666..',
      '.63336663336.',
      '.63.36663.36.',
      '.63336263336.',
      '.66662226666.',
      '..666.2.666..',
      '..66E666E66..',
      '...666P666...',
      '....66.66....',
      '.............',
    ],
  },
  {
    name: 'Cardiac Unit',
    rows: [
      '.............',
      '..111...111..',
      '.18881.18881.',
      '18SS88888SS81',
      '1888888888881',
      '188888E888881',
      '.18888888881.',
      '..188888881..',
      '...1888881...',
      '....18881....',
      '.....1P1.....',
      '......1......',
      '.............',
      '.............',
    ],
  },
  {
    name: 'The Funnel',
    rows: [
      '.............',
      '11.........11',
      '.22.......22.',
      '..33.....33..',
      '...44...44...',
      '....55.55....',
      '.....6.6.....',
      '.....6.6.....',
      '.....6.6.....',
      '....PEEEP....',
      '....77777....',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Orbital Dock',
    rows: [
      '.............',
      '..656...656..',
      '..565...565..',
      '..656...656..',
      '....5...5....',
      '...SSSSSSS...',
      '...S88888S...',
      '...S8P8P8S...',
      '...S88E88S...',
      '...SSSSSSS...',
      '....5...5....',
      '..656...656..',
      '..565...565..',
      '..656...656..',
    ],
  },
  {
    name: 'Upward Bound',
    rows: [
      '.............',
      '.............',
      '......P......',
      '.....333.....',
      '....44444....',
      '...4444444...',
      '..555555555..',
      '.55555E55555.',
      '.....666.....',
      '.....666.....',
      '.....666.....',
      '.....666.....',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Cloudburst',
    rows: [
      '.............',
      '....SSSSS....',
      '..SSSSSSSSS..',
      '.SSSSSESSSSS.',
      '.66666P66666.',
      '..666666666..',
      '.............',
      '.6.6.6.6.6.6.',
      '..6.6.6.6.6..',
      '.6.6.6.6.6.6.',
      '..6.6.6.6.6..',
      '.6.6.6.6.6.6.',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Stairwell',
    rows: [
      '1G.........G1',
      '1G...777...G1',
      '.2G.......G2.',
      '.2G..777..G2.',
      '..3G.....G3..',
      '..3G.777.G3..',
      '...4G...G4...',
      '...4G7E7G4...',
      '....5G.G5....',
      '....5GEG5....',
      '.....6G6.....',
      '.....6G6.....',
      '.....888.....',
      '......P......',
    ],
  },
  {
    name: 'Slice of Life',
    rows: [
      '.............',
      '.22222222222.',
      '.33333333333.',
      '..33E333E33..',
      '..333333333..',
      '...3133313...',
      '...3333333...',
      '....33P33....',
      '....33333....',
      '.....313.....',
      '.....333.....',
      '......3......',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Drifting Jelly',
    rows: [
      '.............',
      '....88888....',
      '...8888888...',
      '..888888888..',
      '.88E88888E88.',
      '.88858885888.',
      '.88888P88888.',
      '.8.888.888.8.',
      '..7.7.7.7.7..',
      '..7..7.7..7..',
      '...7.7.7.7...',
      '..7...7...7..',
      '...7..7..7...',
      '.............',
    ],
  },
  {
    name: 'Skeleton Key',
    rows: [
      '.............',
      '..SSSSSS.....',
      '.SS....SS....',
      '.S...P..S....',
      '.SS....SS....',
      '..SSSSSS.....',
      '....33.......',
      '....33.......',
      '....33.......',
      '....33.......',
      '....33333....',
      '....33.......',
      '....3333333..',
      '.............',
    ],
  },
  {
    name: 'Gold Colonnade',
    rows: [
      '.............',
      '4...4...4...4',
      '4...4...4...4',
      '4.G.4.G.4.G.4',
      '4.G.4.G.4.G.4',
      '5.G.5.G.5.G.5',
      '5.G.P.G.P.G.5',
      '5.G.5.G.5.G.5',
      '6.G.6.G.6.G.6',
      '6.G.6.G.6.G.6',
      '6...6...6...6',
      '6...6...6...6',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Debris Belt',
    rows: [
      '...2.....2...',
      '..272...272..',
      '..2E2...2E2..',
      '...7.....7...',
      '.2.........2.',
      '77....E....77',
      '7E7..S2S..7E7',
      '.7...SES...7.',
      '.....S2S.....',
      '..2.......2..',
      '.727.....727.',
      '..2.......2..',
      '....7...7....',
      '.....E.E.....',
    ],
  },
  {
    name: 'Give and Take',
    rows: [
      '.............',
      '.............',
      '.....444.....',
      '.....444.....',
      '.....444.....',
      '.44444E44444.',
      '.44444P44444.',
      '.....444.....',
      '.....444.....',
      '.....444.....',
      '.............',
      '..111111111..',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Solar Flare',
    rows: [
      '3.....3.....3',
      '.3....3....3.',
      '..3...3...3..',
      '.....222.....',
      '....23332....',
      '...2333332...',
      '33.E33P33E.33',
      '...2333332...',
      '....23332....',
      '.....222.....',
      '..3...3...3..',
      '.3....3....3.',
      '3.....3.....3',
      '.............',
    ],
  },
  {
    name: 'Bank Shot',
    rows: [
      '3P.........P3',
      '33.........33',
      'GG.........GG',
      '....G...G....',
      '..E.2.2.2.E..',
      '.GGG.GGG.GGG.',
      '...2.2.2.2...',
      '.GG.......GG.',
      '...7.7.7.7...',
      'GGG.......GGG',
      '...E.888.E...',
      '..GG.GGG.GG..',
      '55.........55',
      '5P.........P5',
    ],
  },
  {
    name: 'Beep Boop',
    rows: [
      '.............',
      '...E.....E...',
      '...S.....S...',
      '..SSSSSSSSS..',
      '..766666667..',
      '..7.33.33.7..',
      '..7.33.33.7..',
      '..7666P6667..',
      '..761111167..',
      '..761.1.167..',
      '..766666667..',
      '..777777777..',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Serpentine',
    rows: [
      '.111.........',
      '.13144444444.',
      '...........4.',
      '.44444444444.',
      '.4...........',
      '.55555555555.',
      '...........5.',
      '.4444E4E4444.',
      '.4...........',
      '.55555555555.',
      '...........5.',
      '.4444P444444.',
      '.44..........',
      '.............',
    ],
  },
  {
    name: 'Hot Zone',
    rows: [
      '.............',
      '....77777....',
      '..337777733..',
      '.33377777333.',
      '3333377733333',
      '3333777773333',
      '333377P773333',
      '3337777777333',
      '3377773777733',
      '.E777333777E.',
      '..777333777..',
      '....33333....',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Bricklayer',
    rows: [
      '.............',
      '.............',
      '22.222.222.22',
      '.222.222.222.',
      '33.333.333.33',
      '.333.333.333.',
      '44.4P4.4P4.44',
      '.444.444.444.',
      '55.555.555.55',
      '.555.555.555.',
      '66.666.666.66',
      '.666.666.666.',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Signal Dish',
    rows: [
      '.5.........5.',
      '.5...S.S...5.',
      '.5....P....5.',
      '.5...S.S...5.',
      '.5.........5.',
      '.55.......55.',
      '..555...555..',
      '...5555555...',
      '......6......',
      '.....666.....',
      '....6...6....',
      '...6.....6...',
      '..66.....66..',
      '.............',
    ],
  },
  {
    name: 'The Big Question',
    rows: [
      '.............',
      '...7777777...',
      '..77.....77..',
      '..77.....77..',
      '........666..',
      '.......666...',
      '......555....',
      '.....555.....',
      '.....555.....',
      '.............',
      '.....8P8.....',
      '.....888.....',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Ridgeline',
    rows: [
      '.............',
      '.............',
      '......S......',
      '.....SSS.....',
      '....6SSS6....',
      '..S..666..S..',
      '.SSS.666.SSS.',
      '.66666666666.',
      '666666E666666',
      '666P66666P666',
      '.55555555555.',
      '..555555555..',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Hedge Maze',
    rows: [
      '.............',
      '.4.4.4.4.4.4.',
      '.GG...G...GG.',
      '.4.4.4.4.4.4.',
      '...GG...GG...',
      '.5.5.5.5.5.5.',
      '.GG...G...GG.',
      '.5.5.E.E.5.5.',
      '...GG...GG...',
      '.6.6.6.6.6.6.',
      '.GG...G...GG.',
      '.6.6.6.6.6.6.',
      '...GG...GG...',
      '...P..E..P...',
    ],
  },
  {
    name: 'Two Beats',
    rows: [
      '.............',
      '..66E6P6E66..',
      '..666666666..',
      '..6.......6..',
      '..6.......6..',
      '..6.......6..',
      '..6.......6..',
      '..6.......6..',
      '..6.......6..',
      '..6.......6..',
      '.888.....888.',
      '.888.....888.',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Dragon Maw',
    rows: [
      '.............',
      '.G.........G.',
      '.G4.......4G.',
      '..44.....44..',
      '..444444444..',
      '.44444444444.',
      '.44144444144.',
      '.4444.4.4444.',
      '..444444444..',
      '..S.S.S.S.S..',
      '...11EEE11...',
      '....11P11....',
      '.....111.....',
      '.............',
    ],
  },
  {
    name: 'Crown Jewels',
    rows: [
      '.............',
      '.............',
      '......1......',
      '..1...3...1..',
      '..3..333..3..',
      '.333.333.333.',
      '.33333333333.',
      '.33333333333.',
      '.3E333P333E3.',
      '.SSSSSSSSSSS.',
      '..SSSSSSSSS..',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Powder Keg',
    rows: [
      '.............',
      '.............',
      '..SSSSSSSSS..',
      '..677777776..',
      '..67EEEEE76..',
      '..67E888E76..',
      '..67E8P8E76..',
      '..67E888E76..',
      '..67EEEEE76..',
      '..677777776..',
      '..SSSSSSSSS..',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Singularity',
    rows: [
      '.............',
      '.77777777777.',
      '...........7.',
      '...........7.',
      '.76666E666.7.',
      '.7.......6.7.',
      '.7.5555..6.7.',
      '.7.5..P..6.7.',
      '.7.6666666.7.',
      '.7.........7.',
      '.7.........7.',
      '.77777777777.',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Loud and Clear',
    rows: [
      '.............',
      '.....111.....',
      '.....111.....',
      '.22..222..22.',
      '.22..222..22.',
      '.33..333..33.',
      '.33..333..33.',
      '.44..444..44.',
      '.44..444..44.',
      '.............',
      '.66..6P6..66.',
      '.66..666..66.',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Rolling Swell',
    rows: [
      '.............',
      '55....E....55',
      '555..555..555',
      '..5555.5555..',
      '...55...55...',
      '66....6....66',
      '666..666..666',
      '..6666.6666..',
      '...6P...P6...',
      '77....7....77',
      '777..777..777',
      '..7777.7777..',
      '...77...77...',
      '.............',
    ],
  },
  {
    name: 'Cell Block',
    rows: [
      '.............',
      'G...G...G...G',
      'G111G222G333G',
      'G1P1G2E2G3P3G',
      'G1.1G2.2G3.3G',
      'G111G222G333G',
      'GG.GGG.GGG.GG',
      'G444G555G666G',
      'G4P4G5E5G6P6G',
      'G4.4G5.5G6.6G',
      'G444G555G666G',
      'G...G...G...G',
      '..8.8.8.8.8..',
      '.............',
    ],
  },
  {
    name: 'High Roller',
    rows: [
      '.............',
      '...6666666...',
      '...6S333S6...',
      '...6S333S6...',
      '...633E336...',
      '...6333336...',
      '...6S3P3S6...',
      '...6S333S6...',
      '...6333336...',
      '...633E336...',
      '...6S333S6...',
      '...6S333S6...',
      '...6666666...',
      '.............',
    ],
  },
  {
    name: 'Pond Hopper',
    rows: [
      '.............',
      '.............',
      '.............',
      '..44.....44..',
      '..333...333..',
      '..3.3...3.3..',
      '..444444444..',
      '.44444444444.',
      '.44444P44444.',
      '.4.11E1E11.4.',
      '..444444444..',
      '...4444444...',
      '.44.4...4.44.',
      '.............',
    ],
  },
  {
    name: 'Sands of Time',
    rows: [
      '.............',
      '.SSSSSSSSSSS.',
      '.53333333335.',
      '..533333335..',
      '...5333335...',
      '....53335....',
      '.....5P5.....',
      '....5...5....',
      '...5.....5...',
      '..5.......5..',
      '.5....2....5.',
      '.5..22222..5.',
      '.SSSSSSSSSSS.',
      '.............',
    ],
  },
  {
    name: 'Comb Filter',
    rows: [
      '.............',
      '.55555555555.',
      '.5.5.5.5.5.5.',
      '.5.5.5.5.5.5.',
      '.5.5.5.5.5.5.',
      '..P.......P..',
      '.............',
      '..7.7.7.7.7..',
      '..7.7.7.7.7..',
      '..7.7.7.7.7..',
      '.77777777777.',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Solar Wing',
    rows: [
      '.............',
      '55555...55555',
      '56665.S.56665',
      '56665.S.56665',
      '55555.S.55555',
      '......S......',
      '.....SPS.....',
      '.....SPS.....',
      '......S......',
      '55555.S.55555',
      '56665.S.56665',
      '56665.S.56665',
      '55555...55555',
      '.............',
    ],
  },
  {
    name: 'Hash Marks',
    rows: [
      '.............',
      '...55...55...',
      '.P.55...55...',
      '...55...55...',
      '.66666666666.',
      '.66E66666E66.',
      '...55...55...',
      '...55...55...',
      '.66E66666E66.',
      '.66666666666.',
      '...55...55...',
      '...55...55.P.',
      '...55...55...',
      '.............',
    ],
  },
  {
    name: 'Desert Sentinel',
    rows: [
      '.............',
      '.....888.....',
      '.....4P4.....',
      '.88..444..88.',
      '.44..444..44.',
      '.44..444..44.',
      '.44..4E4..44.',
      '.44444444444.',
      '.....444.....',
      '.....4P4.....',
      '.....444.....',
      '.....444.....',
      '....44444....',
      '.............',
    ],
  },
  {
    name: 'Pinwheel',
    rows: [
      '.............',
      '.GGGGGG......',
      '.....G7.888..',
      '.....G7.8P8..',
      '.....G7.888..',
      '.....G7......',
      '..777GE......',
      '......EG777..',
      '......7G.....',
      '..888.7G.....',
      '..8P8.7G.....',
      '..888.7G.....',
      '......GGGGGG.',
      '.............',
    ],
  },
  {
    name: 'Buried Treasure',
    rows: [
      '.............',
      '.............',
      '...2222222...',
      '..222222222..',
      '.22222222222.',
      '.3333GGG3333.',
      '.1111G.G1111.',
      '.1111GGG1111.',
      '.11111111111.',
      '.1E111P111E1.',
      '.11111111111.',
      '.SSSSSSSSSSS.',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Busy Bee',
    rows: [
      '.............',
      '.............',
      '..7.......7..',
      '...7.....7...',
      '...3333333...',
      '...3733373...',
      '..333333333..',
      '.S777777777S.',
      '.S3333P3333S.',
      '.S777777777S.',
      '..333333333..',
      '...7777777...',
      '....33333....',
      '......E......',
    ],
  },
  {
    name: 'Equilibrium',
    rows: [
      '.............',
      '....55557....',
      '..555555577..',
      '.55557P75577.',
      '.55557775577.',
      '5555555557777',
      '5555555577777',
      '5555577777777',
      '5555777777777',
      '.55775557777.',
      '.55775E57777.',
      '..557777777..',
      '....57777....',
      '.............',
    ],
  },
  {
    name: 'Hourglass',
    rows: [
      '.............',
      '111.......111',
      '.111.....111.',
      '..222...222..',
      '...222.222...',
      '....33333....',
      '....3.E.3....',
      '....33333....',
      '...444.444...',
      '..444...444..',
      '.555.....555.',
      '555.......555',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Perihelion',
    rows: [
      '.............',
      '.............',
      '.............',
      '..1..........',
      '.....233.....',
      '...2233333...',
      '.1223333SES..',
      '11223333SES..',
      '.1223333SES..',
      '...2233333...',
      '.....233.....',
      '..1..........',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Ampersand Alley',
    rows: [
      '.............',
      '...7777......',
      '..77..77.....',
      '..77..77.....',
      '...7777......',
      '..7777.......',
      '.888.55...55.',
      '888...55.55..',
      'P88....5E5...',
      '888...55.55..',
      '.888.55...55.',
      '..7777.....55',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Silk Trap',
    rows: [
      'S.....7.....S',
      '.7...777...7.',
      '..7.7.7.7.7..',
      '...7..7..7...',
      '..7.77P77.7..',
      '.7..77777..7.',
      'S77777E77777S',
      '.7..77777..7.',
      '..7.77P77.7..',
      '...7..7..7...',
      '..7.7.7.7.7..',
      '.7...777...7.',
      'S.....7.....S',
      '.............',
    ],
  },
  {
    name: 'The Sieve',
    rows: [
      '.............',
      '.............',
      '.11111111111.',
      '1G11G111G11G1',
      '.22222222222.',
      '22G222G222G22',
      '.33333333333.',
      'G33G33333G33G',
      '.44444444444.',
      '4G444G4G444G4',
      '..E.E.E.E.E..',
      '....P...P....',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Bright Idea',
    rows: [
      '..1.......1..',
      '.....333.....',
      '.1..33333..1.',
      '...3333333...',
      '1..332P233..1',
      '...3332333...',
      '....33333....',
      '....SSSSS....',
      '.....666.....',
      '....SSSSS....',
      '.....666.....',
      '.....SSS.....',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Ghost in the Grid',
    rows: [
      '.............',
      '.............',
      '....77777....',
      '...7777777...',
      '..777777777..',
      '.77777777777.',
      '.77SS777SS77.',
      '.77SG777GS77.',
      '.77777777777.',
      '.77E77P77E77.',
      '.77777777777.',
      '.7.77.7.77.7.',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Quarantine',
    rows: [
      '.............',
      '..444...444..',
      '.44444.44444.',
      '.44.44.44.44.',
      '.44.44.44.44.',
      '.4444...4444.',
      '..444...444..',
      '...444.444...',
      '....4EEE4....',
      '...4444444...',
      '..444...444..',
      '..44..P..44..',
      '..444444444..',
      '.............',
    ],
  },
  {
    name: 'Arrow Volley',
    rows: [
      '.............',
      '......8......',
      '.....888.....',
      '....88.88....',
      '...88...88...',
      '..88.....88..',
      '.88.......88.',
      '......P......',
      '.....555.....',
      '....55.55....',
      '...55...55...',
      '..SS.....SS..',
      '.SS.......SS.',
      '.............',
    ],
  },
  {
    name: 'Soft Landing',
    rows: [
      '.............',
      '......5......',
      '....SSSSS....',
      '....S3P3S....',
      '....SSSSS....',
      '..G2222222G..',
      '..2222E2222..',
      '..G2222222G..',
      '..S..5E5..S..',
      '.S....E....S.',
      'S...........S',
      'GG.........GG',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Neon Ten',
    rows: [
      '.............',
      '.............',
      '666666E666666',
      '6663666633366',
      'P63366636663P',
      '6663666366336',
      'E66366636363E',
      '6663666336636',
      '6663666366636',
      '6633366633366',
      '666666E666666',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'The Hive',
    rows: [
      '.222.222.222.',
      '2333233323332',
      '2333233323332',
      '.222.222.222.',
      '2...2...2...2',
      '2.P.2...2.P.2',
      '.222.GGG.222.',
      '233323E323332',
      '2333233323332',
      '.222.222.222.',
      '2...2...2...2',
      '2...2...2...2',
      '.222.222.222.',
      '.............',
    ],
  },
  {
    name: 'Iris Gate',
    rows: [
      '.............',
      '.GG.G...G.GG.',
      '.G22.....22G.',
      '.G22.....22G.',
      '.GGGG...GGGG.',
      '.............',
      '....E777E....',
      '....E7P7E....',
      '.GGGG...GGGG.',
      '.G33.....33G.',
      '.G33.....33G.',
      '.GG.G...G.GG.',
      '..8.8.8.8.8..',
      '.............',
    ],
  },
  {
    name: 'Make a Wish',
    rows: [
      '...E..E..E...',
      '...S..S..S...',
      '...S..S..S...',
      '..888888888..',
      '..8.8.8.8.8..',
      '..777777777..',
      '..7777P7777..',
      '.88888888888.',
      '.8.8.8.8.8.8.',
      '.66666666666.',
      '.66666666666.',
      '.6666EEE6666.',
      '.SSSSSSSSSSS.',
      '.............',
    ],
  },
  {
    name: 'Tuxedo Waddler',
    rows: [
      '.............',
      '.............',
      '....66666....',
      '...6666666...',
      '..66.666.66..',
      '..666626666..',
      '.66655555666.',
      '.66555555566.',
      '.665E5P5E566.',
      '.66555555566.',
      '.66655555666.',
      '..666666666..',
      '...22...22...',
      '.............',
    ],
  },
  {
    name: 'Aegis',
    rows: [
      '.............',
      '.SSSSSSSSSSS.',
      '.S666636666S.',
      '.S666636666S.',
      '.S3333P3333S.',
      '.S666636666S.',
      '..S6663666S..',
      '..S6663666S..',
      '...S66366S...',
      '...S66366S...',
      '....S636S....',
      '.....S3S.....',
      '......G......',
      '.............',
    ],
  },
  {
    name: 'Crosshatch',
    rows: [
      '.............',
      '.............',
      '5555555555555',
      '5..5..5..5..5',
      '5..5..5..5..5',
      '6666666666666',
      '6..6P.6.P6..6',
      '6..6..6..6..6',
      '7777777777777',
      '7..7..7..7..7',
      '7..7..7..7..7',
      '8888888888888',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Stellar Nursery',
    rows: [
      '.............',
      '.............',
      '...7777777...',
      '.77788888777.',
      '77E8811188E77',
      '777881E188777',
      '777881P188777',
      '77E8811188E77',
      '.77788888777.',
      '...7777777...',
      '.............',
      '.............',
      '.............',
      '.............',
    ],
  },
  {
    name: 'Colossus',
    scale: 'giant',
    rows: [
      '111111',
      '222222',
      '333333',
      '44GG44',
      '555555',
      '666666',
      '777777',
    ],
  },
  {
    name: 'Heavy Industry',
    scale: 'giant',
    rows: [
      'S.S.S.',
      '2.4.6.',
      '365E76',
      '4.6.8.',
      '567E16',
      '6.8.2.',
      'S.S.S.',
    ],
  },
  {
    name: 'Four Corners',
    scale: 'giant',
    rows: [
      '88..88',
      '88..88',
      '88..88',
      'G.PP.G',
      '55..55',
      '55..55',
      '55..55',
    ],
  },
  {
    name: 'The Monolith',
    scale: 'giant',
    rows: [
      '.7777.',
      '.SSSS.',
      '.7777.',
      '.SSSS.',
      '.7777.',
      '.SSSS.',
      '..EE..',
    ],
  },
  {
    name: 'Boulder Field',
    scale: 'giant',
    rows: [
      '41G64G',
      '27G4.1',
      '7G3353',
      'E42P7.',
      '84..56',
      '.2E682',
      '.668G2',
    ],
  },
  {
    name: 'Pixel Perfect',
    scale: 'mini',
    rows: [
      '..........................',
      '..........................',
      '.111111111111111111111111.',
      '.222222222222222222222222.',
      '.222222222222222222222222.',
      '.222222222222222222222222.',
      '.333333333333333333333333.',
      '.333333333333333333333333.',
      '.333333333333333333333333.',
      '.444444444444444444444444.',
      '.444444444444444444444444.',
      '.444444444444444444444444.',
      '.555555555555555555555555.',
      '.555555555555555555555555.',
      '.555555555555555555555555.',
      '.666666666666666666666666.',
      '.666666666666666666666666.',
      '.666666666666666666666666.',
      '.777777777777777777777777.',
      '.777777777777777777777777.',
      '.777777777777777777777777.',
      '.888888888888888888888888.',
      '.888888888888888888888888.',
      '.888888888888888888888888.',
      '.111111111111111111111111.',
      '.111111111111111111111111.',
      '..........................',
      '..........................',
    ],
  },
  {
    name: 'Micro Circuit',
    scale: 'mini',
    rows: [
      'S6666S6666S6666S6666S6666S',
      '5....5....5....5....5....5',
      '5....5....5....5....5....5',
      '5....5....5....5....5....5',
      'S6666S6666S6666S6666S6666S',
      '5....5....5....5....5....5',
      '5....5....5....5....5....5',
      '5....5....5....5....5....5',
      'S6666S6666S6666S6666S6666S',
      '5....5....5....5....5....5',
      '5....5....5....5....5....5',
      '5....5....5....5....5....5',
      'S6666S6666S6666S6666S6666S',
      '5....5....5....5....5....5',
      '5....5....5....5....5....5',
      '5....5....5....5....5....5',
      'S6666S6666S6666S6666S6666S',
      '5....5....5....5....5....5',
      '5....5....5....5....5....5',
      '5....5....5....5....5....5',
      'S6666S6666S6666S6666S6666S',
      '5....5....5....5....5....5',
      '5....5....5....5....5....5',
      '5....5....5....5....5....5',
      'S6666S6666S6666S6666S6666S',
      '5....5....5....5....5....5',
      '5....5....5....5....5....5',
      '5....5....5....5....5....5',
    ],
  },
  {
    name: 'The Mosaic',
    scale: 'mini',
    rows: [
      '..........................',
      '..........................',
      '............55............',
      '...........5GG5...........',
      '..........5G33G5..........',
      '.........5G3223G5.........',
      '........5G321123G5........',
      '.......5G32188123G5.......',
      '......5G3218778123G5......',
      '.....5G32187GG78123G5.....',
      '....5G32187G55G78123G5....',
      '...5G32187G5445G78123G5...',
      '..5G32187G543345G78123G5..',
      '.5G32187G54322345G78123G5.',
      '.5G32187G54322345G78123G5.',
      '..5G32187G543345G78123G5..',
      '...5G32187G5445G78123G5...',
      '....5G32187G55G78123G5....',
      '.....5G32187GG78123G5.....',
      '......5G3218778123G5......',
      '.......5G32188123G5.......',
      '........5G321123G5........',
      '.........5G3223G5.........',
      '..........5G33G5..........',
      '...........5GG5...........',
      '............55............',
      '..........................',
      '..........................',
    ],
  },
  {
    name: 'Nano Swarm',
    scale: 'mini',
    rows: [
      '..........................',
      '...1.....1......2.....2...',
      '....1...1........2...2....',
      '...1111111......2222222...',
      '..11.111.11....22.222.22..',
      '.11111111111..22222222222.',
      '.1.1111111.1..2.2222222.2.',
      '.1.1.....1.1..2.2.....2.2.',
      '....11.11........22.22....',
      '..........................',
      '...3.....3......4.....4...',
      '....3...3........4...4....',
      '...3333333......4444444...',
      '..33.333.33....44.444.44..',
      '.33333333333..44444444444.',
      '.3.3333333.3..4.4444444.4.',
      '.3.3.....3.3..4.4.....4.4.',
      '....33.33........44.44....',
      '..........................',
      '...5.....5......6.....6...',
      '....5...5........6...6....',
      '...5555555......6666666...',
      '..55.555.55....66.666.66..',
      '.55555555555..66666666666.',
      '.5.5555555.5..6.6666666.6.',
      '.5.5.....5.5..6.6.....6.6.',
      '....55.55........66.66....',
      '..........................',
    ],
  },
  {
    name: 'Fine Print',
    scale: 'mini',
    rows: [
      '.112223.344455.666777.8811',
      '..........................',
      '333444.556667.788811.22233',
      '.....P..........P.........',
      '55566.777888.112223.344455',
      '..........................',
      '7778.811122.333444.556667.',
      '..........................',
      '111.223334.455566.777888.1',
      '..........................',
      '33.44P555.667778P811122.33',
      '..........................',
      '5.566677.888111.223334.455',
      '..........................',
      '.778881.122233.444555.6677',
      '..........................',
      '111222.334445.566677.88811',
      '.....P..........P.........',
      '33344.555666.778881.122233',
      '..........................',
      '5556.677788.111222.334445.',
      '..........................',
      '777.881112.233344.555666.7',
      '..........................',
      '11.22P333.445556P677788.11',
      '..........................',
      '3.344455.666777.881112.233',
      '..........................',
    ],
  },
];
